import IconLogo from './IconLogo';
import IconLogoApp from './IconLogoApp';
import IconAppStore from './IconAppStore';
import IconGooglePlay from './IconGooglePlay';
import IconRuStore from './IconRuStore';
import IconArrow from './IconArrow';
import IconHumanPain from './IconHumanPain';
import IconHumanRehabilitation from './IconHumanRehabilitation';
import IconHumanPregnant from './IconHumanPregnant';
import IconHumanAthlete from './IconHumanAthlete';
import IconYogiMan from './IconYogiMan';
import IconRings from './IconRings';
import IconPin from './IconPin';
import IconCloseModal from './IconCloseModal';
import IconDone from './IconDone';
import IconCross from './IconCross';
import IconAboutUs from './IconAboutUs';
import IconPause from './IconPause';
import IconTelegram from './IconTelegram';
import IconMessage from './IconMessage';

export {
  IconLogo,
  IconLogoApp,
  IconAppStore,
  IconGooglePlay,
  IconRuStore,
  IconArrow,
  IconHumanPain,
  IconHumanRehabilitation,
  IconHumanPregnant,
  IconHumanAthlete,
  IconYogiMan,
  IconRings,
  IconPin,
  IconCloseModal,
  IconDone,
  IconCross,
  IconAboutUs,
  IconPause,
  IconTelegram,
  IconMessage
};
